var map = {
	"./ar.json": 5310,
	"./be.json": 5144,
	"./da.json": 9914,
	"./de.json": 5894,
	"./el.json": 4524,
	"./en.json": 4174,
	"./es.json": 6725,
	"./et.json": 6004,
	"./fa.json": 3248,
	"./fi.json": 6808,
	"./fr.json": 4605,
	"./hi.json": 3134,
	"./id.json": 5176,
	"./it.json": 3672,
	"./ja.json": 7980,
	"./ko.json": 9423,
	"./lt.json": 5449,
	"./lv.json": 1103,
	"./ms.json": 4525,
	"./nl.json": 4943,
	"./no.json": 7086,
	"./pl.json": 1029,
	"./pt.json": 7741,
	"./ro.json": 2354,
	"./ru.json": 4600,
	"./sv.json": 8252,
	"./th.json": 7549,
	"./tr.json": 9755,
	"./uk.json": 2749,
	"./ur.json": 1946,
	"./vi.json": 1496,
	"./zh.json": 9527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1796;